import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { faqs } from "../data/serviceData";
import { useTheme } from "../context/ThemeContext";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <section id="faq" className="py-20 sm:py-24 px-5 sm:px-6 md:px-12 lg:px-20">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className={`text-xs uppercase tracking-[0.2em] mb-3 font-mono font-semibold ${isDark ? "text-[#00F0FF]" : "text-brand-teal"}`}>
            Common questions
          </p>
          <h2 className={`font-display font-bold text-4xl lg:text-5xl tracking-tighter ${isDark ? "text-white" : "text-slate-900"}`}>
            FAQ
          </h2>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                  isOpen
                    ? isDark
                      ? "bg-[#141419] border-[#00F0FF]/30"
                      : "bg-white border-brand-blue/25 shadow-[var(--shadow-card)]"
                    : isDark
                      ? "bg-[#0C0C0F] border-[#222226] hover:border-white/20"
                      : "bg-white border-slate-200 hover:border-slate-300 shadow-[var(--shadow-card)]"
                }`}
              >
                <button
                  data-testid={`faq-item-${i}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left"
                >
                  <span className={`font-semibold text-sm sm:text-base pr-4 ${isDark ? "text-white" : "text-slate-900"}`}>
                    {faq.q}
                  </span>
                  <ChevronDown
                    size={16}
                    className={`flex-shrink-0 transition-transform duration-300 ${
                      isOpen
                        ? isDark ? "rotate-180 text-[#00F0FF]" : "rotate-180 text-brand-orange"
                        : "text-[#8F9098]"
                    }`}
                  />
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className={`px-5 pb-5 text-sm leading-relaxed ${isDark ? "text-[#8F9098]" : "text-slate-600"}`}>
                    {faq.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
